import { CALL_API } from 'redux-api-middleware'
export const LOAD_LINE_INFORMATION_REQUEST = 'LOAD_LINE_INFORMATION_REQUEST'
export const LOAD_LINE_INFORMATION_SUCCESS = 'LOAD_LINE_INFORMATION_SUCCESS'
export const LOAD_LINE_INFORMATION_FAILURE = 'LOAD_LINE_INFORMATION_FAILURE'
// import { replace } from 'react-router-redux'
export const SEND_LINE_MESSAGE_REQUEST = 'SEND_LINE_MESSAGE_REQUEST'
export const SEND_LINE_MESSAGE_SUCCESS = 'SEND_LINE_MESSAGE_SUCCESS'
export const SEND_LINE_MESSAGE_FAILURE = 'SEND_LINE_MESSAGE_FAILURE'
import { token } from '../../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
import {
  LINE_MESSAGE_EP,
} from '../../constant'
export const loadLineInformation = (endpoint) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'GET',
        headers,
        types: [
          LOAD_LINE_INFORMATION_REQUEST,
          LOAD_LINE_INFORMATION_SUCCESS,

          // {
          //   type: LOAD_LINE_INFORMATION_SUCCESS,
          //   payload: async (action, state, res) => {
          //     const response = await res.json()
          //     dispatch(messagingToLine(serviceId, "1ขอบคุณที่ให้ความสนใจ\n   เรากำลังค้นหาติวเตอร์ให้กับคุณ\n หากพบติวเตอร์แล้ว เราจะรีบแจ้งให้ทราบทันที"))
          //     dispatch(messagingToLine(serviceId, `2ขอบคุณที่ให้ความสนใจ
          //     เรากำลังค้นหาติวเตอร์ให้กับคุณ\n หากพบติวเตอร์แล้ว
          //     เราจะรีบแจ้งให้ทราบทันที`))
          //     return response
          //   },
          // },
          LOAD_LINE_INFORMATION_FAILURE,
        ],
      },
    })
  }
}
export const messagingToLine = (lineId, message) => {
  // const form = new FormData()
  // form.append('lineId', lineId)
  // form.append('text', message)
  var bodyJson = {
    lineId: lineId,
    text: message
  }
  console.log(JSON.stringify(bodyJson))
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: LINE_MESSAGE_EP,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(bodyJson),
        // body: JSON.parse({
        //   "lineId": lineId,
        //   "text": message
        // }),
        // body: JSON.parse({
        //   "lineId": lineId,
        //   "text": message,
        // }),
        // body: bodyJson,
        types: [
          SEND_LINE_MESSAGE_REQUEST,
          SEND_LINE_MESSAGE_SUCCESS,
          SEND_LINE_MESSAGE_FAILURE,
        ],
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/LineStudentRegister/actions.js